/**
 * Owl 自定义指标上报工具
 * 支持全局和业务模块的指标上报，预设全局维度信息
 * 该文件的埋点和reportOwlMetric.js文件中埋点方式差不多，但是因为该文件可以上报不同的value指标，所以重新写了一份
 */


/**
 * 上报指标到全局 MetricManager
 * @param {string} metricName 指标名称
 * @param {number} value 指标值
 * @param {Object} extraTags 额外的维度标签
 */
export function reportMetric(metricName, value, extraTags = {}) {
    if (!window.owl || typeof window.owl !== 'function') {
        console.error('owlMetricReport Error');
        return;
    }
    try {
        const globalMetricInst = window.owl('newMetricInst');
        if (globalMetricInst) {
            globalMetricInst.setTags({ ...extraTags });
            globalMetricInst.setMetric(metricName, value);
        }
    } catch (error) {
        // Failed to initialize Owl MetricManager
        console.error('owlMetricReport Error', error);
    }
}

export default {};
